import german_messages from './de-at';

export default {
    de: german_messages
};
